document.addEventListener("DOMContentLoaded", function () {

  if (document.querySelector('.js-explore-style-slider')) {

    var swiper = new window.Swiper(".js-explore-style-slider", {
      slidesPerView: "auto",
      lazy: true,
      spaceBetween: 0,
      loop: true,
      freeMode: true,
      breakpoints: {
        992: {
          slidesPerView: 5,
        },
      },
    });

  }

  const productSliders = document.querySelectorAll('.js-product-slider');

  if (productSliders.length > 0) {
    productSliders.forEach(function (slider) {
      new window.Swiper(slider, {
        slidesPerView: "auto",
        lazy: true,
        spaceBetween: 0,
        loop: true,
        freeMode: true,
        breakpoints: {
          992: {
            slidesPerView: 4,
          },
        },
      });
    });
  }

  const productCardSliders = document.querySelectorAll('.js-product-card-slider');

  if (productCardSliders.length > 0) {
    productCardSliders.forEach(function (slider) {
      new window.Swiper(slider, {
        slidesPerView: 1,
        lazy: true,
        spaceBetween: 0,
        loop: true,
        grabCursor: true,
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    });
  }


  // Footer dropdown links
  const dropdownBlocks = document.querySelectorAll('.dropdown__links-block');

  function initDropdowns() {
    const isMobile = window.innerWidth <= 767;

    dropdownBlocks.forEach(block => {
      const title = block.querySelector('.title-text');
      const links = block.querySelector('.links');

      // Reset styles on resize
      block.classList.remove('active');
      links.style.maxHeight = isMobile ? '0' : 'none';
      links.style.overflow = isMobile ? 'hidden' : 'visible';
      links.style.transition = isMobile ? 'max-height 0.3s ease' : 'none';

      // Replace title to reset event listeners
      const newTitle = title.cloneNode(true);
      title.parentNode.replaceChild(newTitle, title);

      if (isMobile) {
        newTitle.addEventListener('click', () => {
          const isActive = block.classList.contains('active');

          // Close all dropdowns
          dropdownBlocks.forEach(b => {
            b.classList.remove('active');
            b.querySelector('.links').style.maxHeight = '0';
          });

          // Open the clicked one
          if (!isActive) {
            block.classList.add('active');
            links.style.maxHeight = links.scrollHeight + 'px';
          }
        });
      }
    });
  }

  initDropdowns();
  window.addEventListener('resize', initDropdowns);


  // scroll down add class in body

  // window.addEventListener("scroll", function () {
  //   if (window.scrollY > 0) {
  //     document.body.classList.add("scrolled-down");
  //   } else {
  //     document.body.classList.remove("scrolled-down");
  //   }
  // });


  if (document.querySelector('.js-top-slider')) {

    var topSwiper = new window.Swiper(".js-top-slider", {
      slidesPerView: 3,
      lazy: true,
      spaceBetween: 16,
      loop: true,
      freeMode: true,
      breakpoints: {
        575: {
          slidesPerView: 4,
        },
        750: {
          slidesPerView: 5,
        },
        830: {
          slidesPerView: 6,
        }
      }
    });

  }


  // mega menu

  const menuItems = document.querySelectorAll('.items.megamenu-nav__links');
  const imageItems = document.querySelectorAll('.items.nav-hover__images');

  menuItems.forEach((menuItem, index) => {

    const submenu = menuItem.querySelector('.submenu');
    const previewImg = imageItems[index]?.querySelector('.menuPreviewImg');

    if (!submenu || !previewImg) return;

    const links = submenu.querySelectorAll('a');
    const defaultSrc = previewImg.src;

    links.forEach(link => {

      link.addEventListener('mouseenter', () => {
        const imgURL = link.dataset.img;
        if (imgURL) {
          previewImg.src = imgURL;
          previewImg.classList.add('show');
          previewImg.classList.remove('hidden');
        } else {
          previewImg.classList.add('hidden');
          previewImg.classList.remove('show');
        }
      });

      link.addEventListener('mouseleave', () => {
        previewImg.src = defaultSrc;
        previewImg.classList.remove('show');
        previewImg.classList.remove('hidden');
      });

      // keyboard focus
      link.addEventListener('focus', () => {
        const imgURL = link.dataset.img;
        if (imgURL) {
          previewImg.src = imgURL;
          previewImg.classList.add('show');
        } else {
          previewImg.classList.add('hidden');
        }
      });

      link.addEventListener('blur', () => {
        previewImg.src = defaultSrc;
        previewImg.classList.remove('show');
        previewImg.classList.remove('hidden');
      });

    });

  });

});

